import styled, { DefaultTheme, StyledComponentProps } from "styled-components";
import {
  baseCSS,
  blockCSS,
  primaryCSS,
  secondaryCSS,
} from "./ButtonLink/styles";

interface ButtonLinkProps {
  styledType?: "primary" | "secondary";
  styledDisplay?: "inline-block" | "block";
}

export interface FullButtonLinkProps
  extends StyledComponentProps<"a", DefaultTheme, ButtonLinkProps, never> {}

export const ButtonLink = styled.a.attrs(provideDefaultProps)<ButtonLinkProps>`
  ${baseCSS}
  ${(props) => (props.styledType === "primary" ? primaryCSS : null)}
  ${(props) => (props.styledType === "secondary" ? secondaryCSS : null)}
  ${(props) => (props.styledDisplay === "block" ? blockCSS : null)}
`;

function provideDefaultProps(props: ButtonLinkProps) {
  const defaultProps: ButtonLinkProps = {
    styledType: "primary",
    styledDisplay: "inline-block",
  };
  return {
    ...defaultProps,
    ...props,
  };
}
